



































import { defineComponent, ref } from "@vue/composition-api";
import { cloneDeep } from "lodash-es";
import { Page } from "@scrile/api-provider/dist/api/PageProvider";
import { checkAuthorities, checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import useSystemSettings from "@/hooks/useSystemSettings";
import providers from "@/lib/api";
import config from "@/config";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";
import DarkModeSwitch from "./components/DarkModeSwitch";
import LocaleSelectItem from "./components/LocaleSelectItem";
import { MoreMenuItem, moreMenu } from "./config";

const DEFAULT_SECTION = "default";

export default defineComponent({
  name: "PageMore",
  components: { LocaleSelectItem, BasePage, PageTitle, BaseButton, BaseIcon, DarkModeSwitch },
  props: {
    section: { type: String, default: DEFAULT_SECTION },
  },
  setup() {
    const { creditCardAllowed } = useSystemSettings();
    const { authUser, authorities } = useAuthUser();
    return { creditCardAllowed, authUser, authorities };
  },
  data() {
    return {
      pages: [] as Page[],
    };
  },
  computed: {
    showDarkModeSwitch(): boolean {
      return config.featureDarkMode && this.section === DEFAULT_SECTION;
    },
    isMember(): boolean {
      return checkRole(this.authUser?.role || "", "member");
    },
    checkedCallAuthorities(): boolean {
      return checkAuthorities(this.authorities, ["updateMyCallPrice"]);
    },
    checkedMessageAuthorities(): boolean {
      return checkAuthorities(this.authorities, ["updateMyMessagePrice"]);
    },
    checkedCallOptionsAuthorities(): boolean {
      return checkAuthorities(this.authorities, ["updateMyCallOptions"]);
    },
    aboutLinks(): MoreMenuItem[] {
      return this.pages.reduce((out, page, index) => {
        if (page.visible) out.push({ label: page.title, href: page.path, name: `term${index}` });
        return out;
      }, [] as MoreMenuItem[]);
    },
    showPriceSettings(): boolean {
      return (
        (config.featureCalling && this.checkedCallAuthorities) ||
        (config.featurePaidSentMessage && this.checkedMessageAuthorities) ||
        this.checkedCallOptionsAuthorities
      );
    },
    menu(): Record<string, { title: string; hideBack: boolean; list: MoreMenuItem[] }> {
      const menu = cloneDeep(moreMenu);
      menu.terms.list = this.aboutLinks;
      return menu;
    },
    title(): string {
      return this.menu[this.section].title;
    },
    hideBack(): boolean {
      return this.menu[this.section].hideBack;
    },
    menuList(): MoreMenuItem[] {
      return this.menu[this.section].list.filter(item => {
        if (item.name === "priceSettings" && !this.showPriceSettings) {
          return false;
        }
        if (!item.filter) {
          return true;
        }
        if (item.filter && item.filter.requiredRole && item.filter.requiredRole.every(i => i !== this.authUser?.role)) {
          return false;
        }
        if (item.filter.forbiddenRole && item.filter.forbiddenRole === this.authUser?.role) {
          return false;
        }
        if (item.filter.requiredAuthorities && !checkAuthorities(this.authorities, item.filter.requiredAuthorities)) {
          return false;
        }
        if (item.filter.requiredCreditCard && !this.creditCardAllowed) {
          return false;
        }
        return true;
      });
    },
  },
  created() {
    providers.PageProvider.find().then(r => (this.pages = r));
  },
});
